import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { automationReceivedRuleList } from "../../../../../../../services/ticketAutomationReceivedRule.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleAllowedAction.";

export const ReturnReceivedRule = () => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(automationReceivedRuleList);

  const [optionsReturnReceivedRule, setReturnReceivedRule] = useState<
    ISelectType[]
  >([]);

  const fetchReturnReceivedRule = useCallback(async () => {
    const { data, success } = await sendRequest({ ticketAutomationCode: 25 });
    if (data && success) {
      setReturnReceivedRule(
        data.map((d) => ({
          id: d.id,
          name: d.name,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchReturnReceivedRule();
  }, [fetchReturnReceivedRule]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        fullWidth
        options={optionsReturnReceivedRule}
        name="returnTicketAutomationReceivedRule"
        label={t(translationPath + "return_received_rule")}
        getOptionLabel={(option) => option.name}
        size="small"
      />
    </Grid>
  );
};
